import React, { Suspense } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

const Recommend = React.lazy(() => import(/* webpackChunkName: 'Recommend' */'./views/recommend'));
const Consume = React.lazy(() => import(/* webpackChunkName: 'Consume' */'./views/consume'));

const renderLoader = (id, payload) => {
  // Default to https://www.autodesk.com if not present
  const apiHost = payload?.apiHost || 'https://www.autodesk.com';
  if (payload.displayType) {
    let ExperienceComponent;
    switch (payload.displayType) {
    case 'recommend':
      ExperienceComponent = Recommend;
      break;
    case 'consume':
      ExperienceComponent = Consume;
      break;
    default: ExperienceComponent = () => <></>;
    }
    try {
      // Try to unmount a previous instance if it exists
      // This allows calling render multiple times with different configs
      unmountComponentAtNode(document.getElementById(id));
    } catch (e) {
      // Do nothing
    }
    render(
      <Suspense fallback={<></>}>
        <ExperienceComponent payload={{ ...payload, apiHost }} containerId={id} />
      </Suspense>,
      document.getElementById(id),
    );
  }
};

window.adsk = window.adsk || {};
window.adsk.components = window.adsk.components || {};
window.adsk.components.learnAnywhereMFE = {
  render: renderLoader,
};
